import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { ADGMPanel, ADGMButton, ADGMImage } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import NoResult from '../../NoResult';

import styles from './styles';

const NoBuyerFound = ({ classes, addBuyerHandler }) => {
  return (
    <ADGMPanel title='OFFPLAN_ONLINE_BUYER_DETAILS' mandatory>
      <NoResult
        title='no_buyer_added_message'
        subTitle='add_buyer_to_continue_with_application'
        customClasses={{ container: classes.noResultContainer }}
      >
        <ADGMButton variant='secondary' className={classes.addBuyerBtn} onClick={addBuyerHandler}>
          <ADGMImage name='add-icon2.svg' alt='add-buyer' />
          {keyEmptyCheck('Add_buyer')}
        </ADGMButton>
      </NoResult>
    </ADGMPanel>
  );
};

NoBuyerFound.propTypes = {
  classes: PropTypes.object.isRequired,
  addBuyerHandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(NoBuyerFound);
